import { usBoundaries } from '@/constants/Project';

export const fetchNeighborhoods = ({ state, city }: { state: string; city: string; district?: number }) => {
  const usStateBoundariesInfo = usBoundaries.find((b) => b.state.short_name === state);

  if (usStateBoundariesInfo) {
    const cityBoundariesInfo = usStateBoundariesInfo.cities.find((b) => b.name === city);

    const neighborhoods = cityBoundariesInfo?.district.map((d) => {
      return d.neighborhoods;
    });

    return neighborhoods?.flat();
  }

  return undefined;
};
